import React from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '../../ui/table';
import { Card, CardContent } from '../../ui/card';
import type { ArchiveCategory } from '../../../api/archiveCategoryApi';
import DocumentTypeTableRow, { DocumentType } from './DocumentTypeTableRow';

interface DocumentTypeTableProps {
  documentTypes: DocumentType[];
  categories: ArchiveCategory[];
  onEdit: (documentType: DocumentType) => void;
  onDelete: (documentType: DocumentType) => void;
}

export default function DocumentTypeTable({
  documentTypes,
  categories,
  onEdit,
  onDelete,
}: DocumentTypeTableProps) {
  const getCategoryName = (catId: number) => {
    return categories.find(c => c.id === catId)?.category_name || '-';
  };

  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Kode</TableHead>
              <TableHead>Nama Dokumen</TableHead>
              <TableHead>Kategori</TableHead>
              <TableHead>Format</TableHead>
              <TableHead className="text-center">Max Size</TableHead>
              <TableHead className="text-center">Mandatory</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Aksi</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {documentTypes.map(doc => (
              <DocumentTypeTableRow
                key={doc.id}
                documentType={doc}
                categoryName={getCategoryName(doc.category_id)}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
